import { Avatar, AvatarFallback } from "@/components/ui";
import { getInitials } from "@/utils/user";

interface ProfileHeaderProps {
  email?: string;
  name?: string;
}

export const ProfileHeader = ({ email, name }: ProfileHeaderProps) => {
  return (
    <div className="flex flex-col items-center">
      <Avatar className="h-24 w-24 bg-zinc-200">
        <AvatarFallback className="bg-zinc-200 font-medium text-lg text-zinc-700">
          {getInitials(email, name)}
        </AvatarFallback>
      </Avatar>
      <p className="mt-4 font-semibold text-zinc-900">{email ?? "—"}</p>
    </div>
  );
};
